<template>
<transition name="fade">
  <div class="thumbView" v-if="visible">
  <div class="closeBtn" @click="close"></div>
    <scroll-content class="thumb-wrapper abs-center" ref="scroll">
      <div class="cont">
      <div class="thumb"
           v-for="(item,index) in srcList"
           :key="item.id"
           >
      <div class="left" v-if="item.leftPage" @click="gotoPage(index)">
        <img :src="item.leftPage.thumburl" />
        <div class="thumb-tag">{{index*2}}</div>
      </div>
      <div class="right" v-if="item.rightPage" @click="gotoPage(index)">
        <img :src="item.rightPage.thumburl" />
        <div class="thumb-tag">{{index*2+1}}</div>
      </div>
      </div>
      </div>
    </scroll-content>
  </div>
</transition>
</template>
<script>
import scrollContent from '@/components/scrollContent.vue';

export default {
  name: 'thumbView',
  props: {
    srcList: Array,
    thumb_visible: Boolean,
  },
  data() {
    return {
      visible1: true,
    };
  },
  computed: {
    visible() {
      return this.thumb_visible;
    },
  },
  mounted() {
    console.log('thumb', this.srcList);
  },
  watch: {
    thumb_visible(val) {
      this.$nextTick(() => { if (val) this.$refs.scroll.getHeight(); });
    },
  },
  methods: {
    getClass(n) {
      return n % 2 ? '' : 'left';
    },
    gotoPage(n) {
      this.$store.commit('updateCurrentPage', {
        currentPage: n,
      });
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
    close() {
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
  },
  components: {
    scrollContent,
  },
};
</script>
<style lang="less" scoped>
.thumbView {
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  position: absolute;
  .cont{
    width: 100%;
    display: inline-block;

  }
  .closeBtn{
     width: 31px;
     height: 31px;
     position: absolute;
     left: 50%;
     top: 50%;
     margin-left: 390px;
     margin-top: -380px;
    background-image: url("~@/assets/icon/imgClose.jpg");
  }
  .thumb-wrapper {
    width: 900px;
    height: 670px;
    overflow: hidden;
    .thumb {
      width: 200px;
      height: 160px;
      float: left;
      margin: 10px;
      justify-content:flex-end;
      position: relative;
      &-tag {
        width: 100px;
        height: 25px;
        line-height: 25px;
        font-size: 10px;
      }
      &-tag:hover{
        background-color:#EEEEEE ;
      }
      .left{
        width: 100px;
        left: 0px;
        background-color: whitesmoke;
        cursor: pointer;
        position: absolute;
      }
      .right{
        width: 100px;
        right: 0px;
        background-color: whitesmoke;
        cursor: pointer;
        position: absolute;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
